import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { AiOutlineMenuUnfold, AiOutlineClose } from "react-icons/ai";
import { FaChevronDown } from "react-icons/fa";
import { NavLink } from 'react-router-dom';
import GetInTouch from '../GetInTouch/getintouch';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const toggleDropdown = (index) => {
    setActiveDropdown(prevIndex => (prevIndex === index ? null : index));
  };

  const closeDropdowns = () => {
    setActiveDropdown(null);
  };

  const handleLinkClick = () => {
    setIsOpen(false); // Close the sidebar
    closeDropdowns(); // Close the dropdowns
  };

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    const handleClickOutside = (event) => {
      if (!event.target.closest('.navbar')) {
        closeDropdowns();
        setIsOpen(false); // Close the sidebar when clicking outside
      }
    };

    window.addEventListener('scroll', handleScroll);
    document.addEventListener('click', handleClickOutside);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-logo">
        <NavLink to="/" onClick={handleLinkClick} className='Logo-container'>
          <img src="https://res.cloudinary.com/dexueorjm/image/upload/v1772688749/ant_icon_v79f5w.png"
            alt="ANV Logo"
            className='logo-icon' />
          <span className='logo-text'>Amaravathi Naturo Tech Pvt Ltd</span>
        </NavLink>
      </div>

      <div className={`navbar-links ${isOpen ? 'active' : ''}`}>
        {isOpen && (
          <div className="navbar-close" onClick={toggleMenu}>
            <AiOutlineClose size={30} />
          </div>
        )}

        <NavLink exact to="/" activeClassName="active" onClick={handleLinkClick}>Home</NavLink>
        <NavLink exact to="/about-us" activeClassName="active" onClick={handleLinkClick}>About us</NavLink>
        <NavLink to="/projects" activeClassName="active" onClick={handleLinkClick}>Projects</NavLink>

        <div className="navbar-dropdown">
          <span
            className="dropdown-link"
            onClick={(e) => {
              e.preventDefault();
              toggleDropdown(0);
            }}
          >
            Services <FaChevronDown className={`dropdown-icon ${activeDropdown === 0 ? 'rotate' : ''}`} />
          </span>
          <div className={`dropdown-content ${activeDropdown === 0 ? 'show' : ''}`}>
            <NavLink to="/farmer-based-project" activeClassName="active" onClick={handleLinkClick} className="sub-cat">Farmer based Multi cropping project</NavLink>
            <NavLink to="/our-services" activeClassName="active" onClick={handleLinkClick} className="sub-cat">Our Services</NavLink>
            <NavLink to="/arg-business" activeClassName="active" onClick={handleLinkClick} className="sub-cat">Business</NavLink>
            <NavLink to="/arg-clinical" activeClassName="active" onClick={handleLinkClick} className="sub-cat">Clinical</NavLink>
            <NavLink to="/our-process" activeClassName="active" onClick={handleLinkClick} className="sub-cat">Our Process</NavLink>
            <NavLink to="/agriTraining" activeClassName="active" onClick={handleLinkClick} className="sub-cat">Training</NavLink>
          </div>
        </div>

        {/* Products Dropdown */}
        <div className="navbar-dropdown">
          <span
            className="dropdown-link"
            onClick={(e) => {
              e.preventDefault();
              toggleDropdown(1);
            }}
          >
            Products <FaChevronDown className={`dropdown-icon ${activeDropdown === 1 ? 'rotate' : ''}`} />
          </span>
          <div className={`dropdown-content ${activeDropdown === 1 ? 'show' : ''}`}>
            <NavLink to="/crops-products" activeClassName="active" onClick={handleLinkClick} className="sub-cat">Crops</NavLink>
            <NavLink to="/ValueEdition" activeClassName="active" onClick={handleLinkClick} className="sub-cat">Value Edition</NavLink>
          </div>
        </div>

        <NavLink to="/contact" activeClassName="active" onClick={handleLinkClick}>Contact</NavLink>
        <NavLink to="/career" activeClassName="active" onClick={handleLinkClick}>Career</NavLink>
        <NavLink to="/gallery" activeClassName="active" onClick={handleLinkClick}>Gallery</NavLink>
      </div>

      <div className="navbar-hamburger" onClick={toggleMenu}>
        <AiOutlineMenuUnfold size={30} />
      </div>

      {/* Popup Component */}
      {isPopupOpen && (
        <div className="popup active">
          <button className='closepopup' onClick={closePopup}>✖</button>
          <GetInTouch />
        </div>
      )}
    </nav>
  );
};

export default Navbar;
